module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication1"
    }
  }, [_c('h2', {
    staticClass: "dedicationText"
  }, [_vm._v("Books by same author")]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Autobiography:")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flight Testing to Win")]), _c('br'), _vm._v("ISBN 1-4116-4825-0")]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mystery Fiction—a Trilogy:")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Flight Too Far")]), _c('br'), _vm._v("A mysterious disaster at Heathrow"), _c('br'), _vm._v("ISBN 0-9553856-3-6")]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Final Flight")]), _c('br'), _vm._v("A Bermuda Triangle mystery"), _c('br'), _vm._v("ISBN 0-9553856-0-1")]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Right Choice")]), _c('br'), _vm._v("An aviation story of deceit and disaster"), _c('br'), _vm._v("ISBN 0-9553856-2-8")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06154376","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VulcanTestPilot_dedication1.vue
// module id = 57
// module chunks = 0